<template>
    <!-- 课程播放 -->
    <div>
        <div class="allBox app-body">
            <page-header @openLoginDiolog="goLogin" :state="isHaveLoginObj" @goExamintercept="judgeIslogin"/>
            <div class="course-play">
                <div class="video-container">
                    <div class="video-nav-bar">
                        <i class="el-icon-arrow-left pointer" @click.stop="handleBack"><span
                            class="back">返回</span></i>
                        <div class="text-center source-name">{{ courseDetail.SourceName }}</div>
                    </div>
                    <template v-if="!isEmpty(courseDetail)">
                        <main class="video-container-player">
                            <vue-core-video-player ref="video-player"
                                                   style="height: 100%"
                                                   :title="courseDetail.SourceName"
                                                   :loop="false"
                                                   :autoplay="false"
                                                   @play="onVideoPlay"
                                                   @timeupdate="onTimeupdate"
                                                   @pause="onPause"
                                                   :cover="courseDetail.ConverImg"
                                                   preload="auto"
                                                   :src="courseDetail.FileUrl"/>
                        </main>
                    </template>
                </div>
                <div class="course-detail">
                    <div class="title">课程详情</div>
                    <div class="desc">{{ courseDetail.Content }}</div>
                </div>
            </div>
        </div>
        <bottomnav/>
    </div>
</template>

<script>
import PageHeader from "@/components/header";
import Bottomnav from "@/components/bottomnav";
import { getSourceDetail, addLeanTime } from "@/api/manage";
import { isEmpty } from "@/utils";
import { throttle } from "lodash";

const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)
export default {
    name: "course-play",
    components: {
        Bottomnav,
        PageHeader
    },
    created() {
        this.addVisibilityListener()
        if (isSafari) {
            window.addEventListener("pagehide", this.onPageHide, false);
        }
        this.getSourceDetail()
        this.throttle = throttle(() => {
            addLeanTime(this.$route.query.SourceId, this.isFirst === false ? 5 : 0).then(res => {
                if (res.isCompleteLoad === true && this.isCompleteCourse !== true) {
                    this.$message.success("课程已完成")
                    this.isCompleteCourse = true
                }
                this.isFirst = false
            }).catch(e => {
                this.isFirst = false
            })
        }, 5000, {
            trailing: false,
            lead: false
        })
    },
    data() {
        return {
            playOptions: {},
            courseDetail: {},
            isHaveLoginObj: "",
        }
    },
    computed: {},
    methods: {
        goLogin() {
            this.loginDiologShow = true
        },
        onPause () {
            this.throttle.cancel()
        },
        onVideoPlay(video) {
            if (this.firstPlay === true || parseInt(this.courseDetail.TimeNum) === 0) return
            this.firstPlay = true
            // 如果没看完，就跳到上一次的基础之上继续看
            if (Math.floor(video.target.duration) > this.courseDetail.TimeNum) {
                video.target.currentTime = this.courseDetail.TimeNum
            }
        },
        // 该函数每隔250毫秒触发一次
        onTimeupdate(video) {
            const currentTime = video.target.currentTime
            const duration = Math.floor(video.target.duration)
            if (this.maxVideoTime >= duration) {
                this.durationCount = (this.durationCount || 0) + 1
                this.maxVideoTime = duration + this.durationCount
                this.throttle()
            } else if (currentTime > this.maxVideoTime) {
                this.maxVideoTime = currentTime
                this.throttle()
            }
        },
        isEmpty,
        // 获取课程详情
        getSourceDetail() {
            const SourceId = this.$route.query.SourceId
            if (!SourceId) return
            getSourceDetail(SourceId).then(res => {
                this.courseDetail = res
                this.maxVideoTime = res.TimeNum
                this.seeking()
            })
        },
        // 判断是否登录
        judgeIslogin() {
            let token = this.$store.state.user
            if (!token || token === "null") {
                this.goLogin()
            }
        },
        addVisibilityListener() {
            const hiddenProperty = "hidden" in document ? "hidden" : "webkitHidden" in document ? "webkitHidden" : "mozHidden" in document ? "mozHidden" : null;
            const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, "visibilitychange");
            document.addEventListener(visibilityChangeEvent, this.onVisibilityChange, false);
        },
        removeVisibilityListener() {
            const hiddenProperty = "hidden" in document ? "hidden" : "webkitHidden" in document ? "webkitHidden" : "mozHidden" in document ? "mozHidden" : null;
            const visibilityChangeEvent = hiddenProperty.replace(/hidden/i, "visibilitychange");
            document.removeEventListener(visibilityChangeEvent, this.onVisibilityChange, false);
        },
        onVisibilityChange(event) {
            const videoPlayer = this.$refs["video-player"]
            if (videoPlayer.$player.$video.paused === true) return
            if (document.visibilityState === "visible") {
                videoPlayer.play();
            } else {
                videoPlayer.pause();
            }
        },
        onPageHide() {
            const videoPlayer = this.$refs["video-player"]
            if (videoPlayer.$player.$video.paused === true) return
            videoPlayer.pause();
        },
        handleBack() {
            this.$router.go(-1)
        },
        // 监听跳帧操作开始
        seeking () {
            this.$nextTick().then(res => {
                const videoPlayer = this.$refs["video-player"].$player.$video
                videoPlayer.onseeking = (video) => {
                    const currentTime = video.target.currentTime
                    // 禁止快进
                    if (currentTime > this.maxVideoTime) {
                        video.target.currentTime = this.maxVideoTime
                    } else {
                        this.throttle.cancel()
                    }
                }
            })
        }
    },
    beforeDestroy() {
        this.removeVisibilityListener()
        isSafari && window.removeEventListener("pagehide", this.onPageHide, false)
        this.holder && this.holder.removeEventListener("mouseup", this.videoMouseUpHandler, false)
    },
    // beforeRouteLeave(to, from, next) {
    //     const videoPlayer = this.$refs["video-player"].$player.$video
    //     const duration = Math.floor(videoPlayer.duration)
    //     const timNum = this.courseDetail.TimeNum
    //     if (duration > timNum) {
    //         if (this.maxVideoTime <= this.courseDetail.TimeNum) {
    //             next()
    //         } else {
    //             const learnTime = Math.floor(this.maxVideoTime) - timNum
    //             addLeanTime(this.$route.query.SourceId, learnTime).then(res => {
    //                 if (res.isCompleteLoad === true) {
    //                     this.$message.success("课程已完成")
    //                 }
    //                 next()
    //             }).catch(e => {
    //                 next()
    //             })
    //         }
    //     } else {
    //         if (this.durationCount) {
    //             addLeanTime(this.$route.query.SourceId, Math.floor(this.durationCount / 4)).then(res => {
    //                 if (res.isCompleteLoad === true) {
    //                     this.$message.success("课程已完成")
    //                 }
    //                 next()
    //             }).catch(e => {
    //                 next()
    //             })
    //         } else {
    //             next()
    //         }
    //     }
    // }
}
</script>

<style scoped lang="less">
.video-container {
    width: 75%;
}

.course-play {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 10px auto 30px;

    .course-detail {
        flex: 1;
        margin-left: 2%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 30px;

        .title {
            font-size: 16px;
            font-weight: 600;
            box-sizing: border-box;
        }

        .desc {
            font-size: 14px;
            line-height: 26px;
            margin-top: 30px;
        }
    }
}

.video-nav-bar {
    width: 100%;
    background-color: #000;
    color: #fff;
    padding: 20px 10px;
    font-size: 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .back {
        font-size: 15px;
        cursor: pointer;
        margin-left: 4px;
    }

    .source-name {
        flex: 1;
        text-align: center;
        position: relative;
    }

}

.video-container-player {
    width: 100%;
    height: 65vh;
}
</style>
<!--getSourceDetail() {-->
<!--const SourceId = this.$route.query.SourceId-->
<!--if (!SourceId) return-->
<!--getSourceDetail(SourceId).then(res => {-->
<!--this.playOptions = {-->
<!--muted: false,-->
<!--playbackRates: [0.5, 1.0, 1.5, 2.0],-->
<!--sources: [{-->
<!--type: "video/mp4",-->
<!--src: res.FileUrl-->
<!--}],-->
<!--fluid: false,-->
<!--loop: false,-->
<!--preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）-->
<!--language: "zh-CN",-->
<!--poster: res.ConverImg,-->
<!--width: (document.body.offsetWidth * 0.6 * 0.8) + "px",-->
<!--height: (document.body.offsetHeight - 50 - 150) + "px",-->
<!--controlBar: {-->
<!--timeDivider: true,-->
<!--durationDisplay: true,-->
<!--remainingTimeDisplay: false,-->
<!--currentTimeDisplay: true, // 当前时间-->
<!--volumeControl: false, // 声音控制键-->
<!--playToggle: true, // 暂停和播放键-->
<!--progressControl: true, // 进度条-->
<!--fullscreenToggle: true, // 全屏按钮-->
<!--}-->
<!--}-->
<!--this.courseDetail = res-->
<!--})-->
<!--},-->
